module.exports = __webpack_public_path__ + "static/media/medal-silver-v2.1d05e2f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ResultHeader/assets/medals/medal-silver-v2.svg
// module id = 1222
// module chunks = 0